var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'appjctheatre':_vm.$store.state.roomlive.playstauts == 'theatre'},attrs:{"id":"app"}},[(_vm.$route.meta.isHeader)?_c('pageheader'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }